import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// import { API_URL } from '@/config'

export const reports = {

  namespaced: true,

  state: {

  },

  getters: {

  },

  mutations: {

  },

  actions: {

  }
}
